import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";

export interface Props {
    paso: number;
    title: React.ReactNode;
    done: boolean;
}

export class Paso extends React.PureComponent<Props> {
    render() {
        const { paso, title, done } = this.props;
        return (
            <div>
                <div className={done ? "alert alert-success" : "alert"} >
                    <h3>
                        <i className={fa(done ? "check" : "clock-o")} />
                        <b>{paso + " "} </b>
                        {title}
                    </h3>
                </div>
                <hr />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cotizador/paso.tsx